/** @type {import('tailwindcss').Config} */
let colors = {
	primary: {
		DEFAULT: '#46d2c4',
		'50': '#f1fcfa',
		'100': '#def7f4',
		'200': '#9df2e4',
		'300': '#59d7ca',
		'400': '#46d2c4',
		'500': '#1ab2a5',
		'600': '#128f87',
		'700': '#13726d',
		'800': '#145b58',
		'900': '#154c49',
	},

	secondary: '#FF6340',
	success: '#46d2c4',
	warning: '#FF6340',
	danger: '#FF6340',
	black: '#181818',
	white: '#FFFFFF',
	body: '#F2F2F2',
	placeholderGray: '#5B5D6B',
	grey: {
		DEFAULT: '#CCCFD2',
		'50': '#F2F2F2',
		'text': '#5B5D6B',
	},
	link: '#46d2c4',
}

let darkColors = {
	primary: {
		DEFAULT: '#46d2c4',
		'50': '#0c2e2c',
		'100': '#145b58',
		'200': '#13726d',
		'300': '#128f87',
		'400': '#46d2c4',
		'500': '#59d7ca',
		'600': '#63e5d3',
		'700': '#9df2e4',
		'800': '#def7f4',
		'900': '#f1fcfa',
	},

	secondary: colors.secondary,
	black: '#CCCCCC',
	white: '#121212',
	body: '#1f1f1f',
	warning: '#a86900',
	// placeholderGray: '#a4a294',
	grey: {
		DEFAULT: '#535353',
		'50': '#1f1f1f',
		// 'text': '#a4a294',
	},
	link: '#46d2c4',
}

module.exports = {
	darkMode: 'dark',
	content: [
		"./resources/**/*.blade.php",
		"./resources/**/*.js",
		"./resources/**/*.jsx",
		"./resources/**/*.ts",
		"./resources/**/*.tsx",
	],
	theme: {
		extend: {
			keyframes: {
				shimmer: {
					'100%': {
						transform: 'translateX(100%)',
					},
				},
			},
		},
		screens: {
			'md': '640px',
			'l': '1080px',
			'xl': '1380px',
		}
	},
	corePlugins: {
		// use a custom preflight instead of the default one
		preflight: false,
	},
	plugins: [
		require("tailwindcss-animation-delay"),
		require('@tailwindcss/typography'),
		require('tailwindcss-themer')({
			defaultTheme: {
				extend: {
					
					height: {
						'header': '64px',
					},

					minHeight: {
						'35': '35px',
					},


					width: {
						'30px': '30px',
						'sidebar': '64px',
						'sidebar-expanded': '240px',
						'toggle': '40px',
					},

					minWidth: {
						'80': '80px',
					},

					maxWidth: {
						'85p': '85%',
						'100': '100px',
					},

					padding: {
						'1.25': '5px',
						'15px': '15px',
					},

					backgroundColor: {
						'body': colors.body,
					},

					colors: colors,

					borderRadius: {
						'primary': '8px'
					},

					borderWidth: {
						'normal': '2px',
						'thin': '1px',
						'thick': '3px',
						'menu': '6px',
					},

					outlineWidth: {
						'normal': '2px',
						'thin': '1px',
						'thick': '3px',
						'menu': '6px',
					},

					placeholderColor: {
						'primary': colors.placeholder
					},


					boxShadow: {
						primary: ' 0px 3px 6px rgb(0 0 0 / 15%)',
						secondary: '1.5px 2.6px 10px rgba(0, 0, 0, 0.16)',
						tableHeader: '0px 8px 8px -2px rgb(0 0 0 / 10%)',
					},

					fontFamily: {
						'OpenSans': ['Open Sans', 'sans-serif'],
						'MaterialIcons': ['Material Symbols Rounded', 'sans-serif'],
						'MaterialIconsNew': ['Material Symbols Rounded new', 'sans-serif'],
					},
					fontSize: {
						'head': '28px',
						'head2': '27px',
						'sub': '25px',
						'sub2': '22px',
						'secondaryHead': '18px',
						'label': '16px',
						'15px': '15px',
						'article': '14px',
						'placeholder': '14px',
						'xxs': '12px',
					},
					fontWeight: {
						'light': '300',
						'normal': '400',
						'medium': '600',
						'bold': '700',
					},
					opacity: {
						'faded': '0.3',
					}
				}
			},
			themes: [
				{
					name: 'dark',
					extend: {
						colors: darkColors,

						backgroundColor: {
							body: darkColors.body,
						},

					}
				}
			]
		})
	],
}